export default {
  props: {
    inputValue: {
      type: [String, Number]
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {
      value: this.inputValue
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/form-input/form-input.js